module.exports = __webpack_public_path__ + "img/dreiecke-gray.d35627a.svg";